<template>


    <div class="page-wrapper page">
        <div class="page-grid-wrapper standardPage">
            <div class="page-grid-fix">
                <article class="grid-container columns-one tick">
                    <section class="section1">
                        <div class="login-register">
                            <p>Not a member? 
                                <router-link to="/register">Register here</router-link>
                            </p>
                        </div>
                        <h1>Forgot Password</h1> 
                    </section>
                    <section class="section2">
                        <div>
                            <form
                            @submit.prevent="forgotPassword"
                            >
                            <BaseInput
                                type="email"
                                label="Email"
                                name="email"
                                v-model="email"
                                autocomplete="email"
                                placeholder="Your email used when register with us."
                                class="mb-4"
                            />
                            <BaseBtn type="submit" text="Send" />
                            </form>
                            <FlashMessage :message="message" :error="error" />
                        </div>
                    </section>
		        </article>      
	        </div>
        </div>
  </div>


</template>

<script>
import { getError } from "../utils/helpers";
import BaseBtn from "../components/BaseBtn";
import BaseInput from "../components/BaseInput";
import AuthService from "../services/AuthService";
import FlashMessage from "../components/FlashMessage";

export default {
  name: "ForgotPassword",
  components: {
    BaseBtn,
    BaseInput,
    FlashMessage,
  },
  data() {
    return {
      email: null,
      error: null,
      message: null,
    };
  },
  methods: {
    forgotPassword() {
      this.error = null;
      this.message = null;
      const payload = {
        email: this.email,
      };
      AuthService.forgotPassword(payload)
        .then(() => (this.message = "Reset password email sent."))
        .catch((error) => (this.error = getError(error)));
    },
  },
};
</script>
